<ng-template #templateRef>
  <form #editorForm="ngForm" name="editRelation" (ngSubmit)="save()" id="crmRelationEditor">
    <h2 class="flex-grow-0" mat-dialog-title>
      {{Copy && Copy.Id ? 'Edit' : 'Add'}} Relation
      <mat-icon *ngIf="Copy.ExternalId" class="text-right" matTooltip="Linked with SAP S4">insert_link</mat-icon>
    </h2>
    <mat-dialog-content class="flex-grow-1" *ngIf="Copy">
      <mat-tab-group>
        <mat-tab label="General">
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>Relation name</mat-label>
                <input [(ngModel)]="Copy.Name" matInput name="Name">
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Relation code</mat-label>
                <input matInput name="Code" [(ngModel)]="Copy.Code"
                       minlength="2">
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.Type" discriminator="Type" model="Relation" name="Type"
                                   placeholder="Type"></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.DefaultCurrency" discriminator="Currency" model="Document" name="DefaultCurrency"
                                   placeholder="Default Currency"></app-dropdown-option>
            </div>
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.DefaultSupplyPlant" discriminator="SupplyPlant" model="Address" name="DefaultSupplyPlant"
                                   [disabled]="true" placeholder="Default SupplyPlant"></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.CustomerGroup" [disabled]="true" discriminator="CustomerGroup" model="Relation"
                                   name="CustomerGroup" placeholder="Customer Group"></app-dropdown-option>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>E-mail</mat-label>
                <input matInput name="Email" type="email"
                       [(ngModel)]="Copy.Email" disabled>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <app-locale-selector [(ngModel)]="Copy.Locale" disabled name="Locale"
                                   placeholder="Language"></app-locale-selector>
            </div>
            <div class="col-md-6">
              <app-account-selector [(ngModel)]="Copy.Representative" placeholder="Representative"
                                    disabled="disabled" name="Representative"
                                    [filter]="{where: {and: [{RoleId: 'Representative'}, {ExternalId: {neq: null}}]}}"
              ></app-account-selector>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Default Contact</mat-label>
                <mat-select name="DefaultContact" [compareWith]="compareFn"
                            [(ngModel)]="Copy.DefaultContact">
                  <ng-container *ngFor="let contact of Copy.Contacts">
                    <mat-option *ngIf="contact.Id" [value]="contact">{{contact.Fullname}}</mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Default Address</mat-label>
                <mat-select name="DefaultAddress" [compareWith]="compareFn"
                            [(ngModel)]="Copy.DefaultAddress">
                  <ng-container *ngFor="let address of Copy.Addresses">
                    <mat-option [value]="address" *ngIf="address.Id">
                      {{address.Street}} {{address.Street}} -
                      {{address.Postcode}} {{address.City}}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-checkbox name="IsBlocked" [(ngModel)]="Copy.IsBlocked">Blocked</mat-checkbox>
            </div>
            <div class="col-md-6">
              <mat-checkbox name="IsApproved" [(ngModel)]="Copy.IsApproved">Approved
              </mat-checkbox>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Reseller">
          <div class="row">
            <div class="col-md-6">
              <app-group-selector name="Groups" [(ngModel)]="Copy.Groups" [multiple]="true"></app-group-selector>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Minimum Order Amount</mat-label>
                <input [(ngModel)]="Copy.FrancoShipment" matInput name="FrancoShipment" step="0.01"
                       type="number">
                <mat-hint>Amount needed for free shipping. If empty > use country's value</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="false" label="Financial">
          <div class="row">
            <div class="col-md-4">
              <app-dropdown-option [(ngModel)]="Copy.VATLiability"
                                   disabled discriminator="VATLiability"
                                   model="Relation" name="VATLiability"
                                   placeholder="VAT Liability"></app-dropdown-option>
            </div>
            <div class="col-md-4">
              <app-dropdown-option [(ngModel)]="Copy.PaymentConditionSales"
                                   disabled discriminator="PaymentConditionSales"
                                   model="Relation" name="PaymentConditionSales"
                                   placeholder="Payment conditions"></app-dropdown-option>
            </div>
            <div class="col-md-4">
              <app-dropdown-option [(ngModel)]="Copy.InvoicingMethod"
                                   disabled discriminator="InvoicingMethod"
                                   model="Relation" name="InvoicingMethod"
                                   placeholder="InvoicingMethod"></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>VAT number</mat-label>
                <input disabled matInput name="VATNumber"
                       [(ngModel)]="Copy.VATNumber">
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <app-dropdown-option [(ngModel)]="Copy.DefaultVATCode"
                                   [required]="Copy.VATLiability?.ExternalId === 'L'" disabled
                                   discriminator="VATCode" model="Document"
                                   name="DefaultVATCode" placeholder="Default VAT Code"></app-dropdown-option>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Discount sales</mat-label>
                <input disabled matInput name="DiscountSales"
                       [ngModel]="Copy.DiscountSales * 100" (ngModelChange)="Copy.DiscountSales = $event / 100">
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Discount purchase</mat-label>
                <input disabled matInput name="DiscountPurchase"
                       [ngModel]="Copy.DiscountPurchase * 100" (ngModelChange)="Copy.DiscountPurchase = $event / 100">
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field>
                <mat-label>Days until a document expires</mat-label>
                <input disabled matInput name="DocumentDueDays"
                       [(ngModel)]="Copy.DocumentDueDays">
              </mat-form-field>
            </div>
            <div class="col-md-2"><br>
              <mat-checkbox [(ngModel)]="Copy.IsReseller" disabled name="IsReseller">Reseller</mat-checkbox>
            </div>
            <div class="col-md-2"><br>
              <mat-checkbox [(ngModel)]="Copy.IsSupplier" disabled name="IsSupplier">Supplier</mat-checkbox>
            </div>
            <div class="col-md-2"><br>
              <mat-checkbox [(ngModel)]="Copy.IsSales" disabled name="IsSales">Customer</mat-checkbox>
            </div>
          </div>
        </mat-tab>
        <mat-tab *ngIf="Copy.Id" label="Contacts">
          <table class="mat-mdc-table mat-elevation-z8">
            <tr>
              <th>Default</th>
              <th>External relation id</th>
              <th>Name</th>
              <th class="text-right">
                <button disabled id="add-contact" mat-icon-button type="button"
                        (click)="cEditor.edit({Relation: Copy})">
                  <mat-icon>add</mat-icon>
                </button>

              </th>
            </tr>
            <tr *ngFor="let Contact of Copy.Contacts" [ngModelGroup]="Contact.randomNumber">
              <td>
                <ng-container *ngIf="Contact.IsDefault">
                  <button mat-icon-button>
                    <mat-icon color="primary">check_circle_outline</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="!Contact.IsDefault">
                  <button mat-icon-button (click)="Copy.DefaultContact = Contact">
                    <mat-icon color="secondary">check_circle_outline</mat-icon>
                  </button>
                </ng-container>
              </td>
              <td>{{Contact.ExternalRelationId}}</td>
              <td>{{Contact.Fullname}}<br>
                {{Contact.Relation?.Name}}
              </td>
              <td class="text-right">
                <button (click)="cEditor.edit(Contact)" disabled mat-icon-button type="button">
                  <mat-icon>edit</mat-icon>
                </button>
                <button (click)="cEditor.duplicate(Contact)" disabled mat-icon-button type="button">
                  <mat-icon>file_copy</mat-icon>
                </button>
                <button disabled mat-icon-button type="button">
                  <mat-icon appConfirmDialog>delete</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </mat-tab>
        <mat-tab *ngIf="Copy.Id" label="Addresses">
          <table class="mat-mdc-table mat-elevation-z8" style="width: 100%;">
            <tr>
              <th *ngIf="_Global.Account?.Role?.Id === 'Admin'"></th>
              <th>Default</th>
              <th>Type</th>
              <th>Active</th>
              <th>AddressID</th>
              <th>Address</th>
              <th class="text-right" style="width: 160px; flex: none">
                <button id="add-address" type="button" mat-icon-button
                        (click)="aEditor.edit({Relation: Copy})">
                  <mat-icon>add</mat-icon>
                </button>
                <button (click)="aiEditor.edit({Relation: Copy})" id="add-multiple-addresses" mat-icon-button
                        type="button">
                  <mat-icon>playlist_add</mat-icon>
                </button>
                <button (click)="openAddressMerger()"  *ngIf="_Global.Account?.Role?.Id === 'Admin'" type="button" mat-icon-button matTooltip="Merge selected addresses" [disabled]="addressesToMerge.length !== 2">
                  <mat-icon>merge_type</mat-icon>
                </button>
              </th>
            </tr>
            <tr *ngFor="let Address of Copy.Addresses" [ngModelGroup]="Address.randomNumber">
              <td *ngIf="_Global.Account?.Role?.Id === 'Admin'">
                <mat-checkbox [checked]="isChecked(Address)" (change)="toggleCheck($event, Address)"></mat-checkbox>
              </td>
              <td>
                <ng-container *ngIf="Address.IsDefault">
                  <button mat-icon-button>
                    <mat-icon color="primary">check_circle_outline</mat-icon>
                  </button>
                </ng-container>
                <ng-container *ngIf="!Address.IsDefault">
                  <button mat-icon-button (click)="Copy.DefaultAddress = Address">
                    <mat-icon color="secondary">check_circle_outline</mat-icon>
                  </button>
                </ng-container>
              </td>
              <td>{{Address.Type?.Value}}</td>
              <td>
                <mat-icon>{{Address.IsActive ? 'check' : 'clear'}}</mat-icon>
              </td>
              <td>{{Address.ExternalRelationId}}</td>
              <td>
                <ng-container *ngIf="Address.Name">{{Address.Name}}<br></ng-container>
                {{Address.Street}} {{Address.Number}}<br/>{{Address.Postcode}}
                {{Address.City}}<br/>{{Address.Country?.Name}}
              </td>
              <td class="text-right" style="width: 160px; flex: none">
                <button type="button" mat-icon-button (click)="aEditor.edit(Address)">
                  <mat-icon>edit</mat-icon>
                </button>
                <button type="button" mat-icon-button (click)="aEditor.duplicate(Address)">
                  <mat-icon>file_copy</mat-icon>
                </button>
                <button type="button" mat-icon-button>
                  <mat-icon appConfirmDialog (confirm)="aEditor.remove(Address)">delete</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </mat-tab>
        <mat-tab label="Accounts" *ngIf="Copy.Id">
          <table class="mat-mdc-table mat-elevation-z8" style="width: 100%;">
            <tr>
              <th>Type</th>
              <th>Role</th>
              <th>Name</th>
              <th>Email</th>
              <th>Language</th>
              <th style="width: 65px; flex:none;">Active</th>
              <th>Received Login</th>
              <th style="width: 100px; flex:none;">Login</th>
              <th style="width: 40px; flex:none;">
                <button type="button" mat-icon-button>
                  <mat-icon (click)="accEditor.edit({Relation: Copy, Locale: Copy.Locale, Role: {Id: 'Reseller'}})">
                    add
                  </mat-icon>
                </button>
              </th>
            </tr>
            <tr *ngFor="let acc of Copy.Accounts">
              <td>
                {{acc.Type?.Value}}
              </td>
              <td>
                {{acc.Role?.Id}}
              </td>
              <td>
                {{acc.getFullName()}}
              </td>
              <td>{{acc.Email}}</td>
              <td>{{acc.Locale?.getFullLocale()}}
              <td style="width: 65px; flex:none;">
                <mat-icon>{{acc.IsActive ? 'check' : 'clear'}}</mat-icon>
              </td>
              <td>{{acc.ReceivedLogin | date:'shortDate'}}</td>
              <td style="width: 100px; flex:none;">
                <!--button type="button" mat-button mat-raised-button (click)="_Global.openURL(env.resellerUrl + '/#/login/' + acc.Id, '_blank')">
                    Login
                </button-->
                <button type="button" mat-button mat-raised-button
                        (click)="_Global.copyURL(env.resellerUrl + '/nl-BE/login/' + acc.Id)">
                  Copy URL
                </button>
              </td>
              <td style="width: 40px; flex:none;">
                <button type="button" mat-icon-button>
                  <mat-icon (click)="accEditor.edit(acc)">edit</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Send a email to create a new password"
                        title="Wachtwoord resetten" type="button"
                        message="E-mail versturen naar {{acc.Email}} met instructies om wachtwoord te resetten?"
                        appConfirmDialog (confirm)="accEditor.retrievePassword(acc)">
                  <mat-icon>mail</mat-icon>
                </button>
              </td>
            </tr>
          </table>
        </mat-tab>
      </mat-tab-group>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="fill-remaining-space"></div>
      <button mat-button mat-raised-button [mat-dialog-close]="true">Close</button>
      <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading || isLoadingEO"></app-button>
    </mat-dialog-actions>
    <app-account-editor #accEditor [List]="Copy?.Accounts" (ListChange)="Copy.Accounts = $event"></app-account-editor>
    <app-crm-contact-editor [hideRelation]="true" #cEditor [List]="Copy?.Contacts"
                            (ListChange)="Copy.Contacts = $event"></app-crm-contact-editor>
    <app-crm-address-editor [hideRelation]="true" #aEditor [List]="Copy?.Addresses"
                            (ListChange)="Copy.Addresses = $event"></app-crm-address-editor>
    <app-import-addresses-wizard #aiEditor
                                 (ListChange)="Copy.Addresses = Copy.Addresses.concat($event)"></app-import-addresses-wizard>
  </form>
</ng-template>


